export default __webpack_public_path__ + "static/media/cart.8294a47e.png";